import React, { Component } from "react";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import NumberFormat from "react-number-format";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../../utils/Loader";

// State
import {
	removeCartProduct,
	removeCartCoupon,
	updateCartQty,
	clearDeleteMsg,
	clearUpdateMsg
} from "../../../store/actions/cart";
import { revertCheckoutAfterCartChanged } from "../../../store/actions/checkout";

// CSS
import "../../../css/cart-item.css";

// Util
import { removeFromCart as removeFromCartGA } from "../../../utils/google-analytics";

class CheckoutSideProducts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showDeleteModal: false,
			showUpdateModal: false,
			item: null,
			updateQty: 0
		};
	}

	componentWillMount() {
		this.props.clearDeleteMsg();
		this.props.clearUpdateMsg();
	}

	handleItemDelete(product) {
		this.props
			.removeCartProduct(product.id)
			.then(() => this.props.revertCheckoutAfterCartChanged());
		removeFromCartGA(product);

		// Conversion Tracking
		// window.gtag('event', 'remove_front_cart', {
		// 	send_to: 'AW-366673725/hUVqCO7Cx6oYEL3-664B',
		// 	currency: 'USD',
		// 	value: product.total,
		// 	items: [{
		// 		item_id: product.sku,
		// 		item_name: product.title,
		// 		quantity: product.qty,
		// 		price: product.price,
		// 		discount: product.price - product.price_final,
		// 	}]
		// });
	}

	handleCouponDelete(couponId) {
		this.props
			.removeCartCoupon(couponId)
			.then(() => this.props.revertCheckoutAfterCartChanged());
	}

	handleItemUpdate(productId) {
		this.props
			.updateCartQty(productId, this.state.updateQty)
			.then(() => this.props.revertCheckoutAfterCartChanged());
	}

	handleQtyKeyPress(event, productId) {
		if (event.key === "Enter") {
			this.props.clearUpdateMsg();
			this.handleItemUpdate(productId);
		}
	}

	quantityChange(event) {
		this.setState({ updateQty: event.target.value });
	}

	closeAction() {
		this.setState({
			showDeleteModal: false,
			showUpdateModal: false,
			item: null,
			updateQty: 0
		});
		this.props.clearDeleteMsg();
		this.props.clearUpdateMsg();
	}

	render() {
		const {
			items,
			codes,
			paymentActive,
			deletedId,
			deleteSuccess,
			deleteError,
			couponDeleteError
		} = this.props;

		return (
			<div>
				{/* PRODUCTS */}
				{items.map((product, i) => {
					return (
						<div
							key={i}
							className={
								"cart-summary-item side-summary-item" +
								(paymentActive ? " no-delete" : "")
							}
						>
							{!paymentActive && (
								<button
									className="delete-btn"
									ref={tooltipParentName =>
										(this.tooltipParentName = tooltipParentName)
									}
									onClick={() =>
										this.setState({
											showDeleteModal: true,
											item: product
										})
									}
								>
									-
								</button>
							)}

							<div className="item-content">
								<div className="item-title">{product.title}</div>
								<div className="line-item variant-sku">
									{product.variant ? (
										<span className="line-title">
											{product.variant.title} - {product.variant.sku}
										</span>
									) : (
										<span className="line-title">{product.sku}</span>
									)}
								</div>
								<div className="line-item quantity-line">
									<span className="line-title">Quantity</span> :{" "}
									<span className="item-qty">{product.qty}</span>
								</div>
							</div>
							<div className="item-price-column">
								<div className="item-price">
									<NumberFormat
										value={product.total}
										displayType={"text"}
										decimalScale={2}
										fixedDecimalScale={true}
										thousandSeparator={true}
										prefix={"$"}
									/>
								</div>
								{!paymentActive && (
									<button
										className="add-qty-btn"
										ref={tooltipParentName =>
											(this.tooltipParentName = tooltipParentName)
										}
										onClick={() =>
											this.setState({
												showUpdateModal: true,
												item: product,
												updateQty: product.qty
											})
										}
									>
										Update
									</button>
								)}
							</div>
						</div>
					);
				})}

				{/* SALE CODES */}
				{codes.map((code, i) => {
					if(code.code_type === "general"){
						return (
							<div key={i} className={"cart-summary-item side-summary-item sale-code-item" + (paymentActive ? " no-delete" : "")} data-id="coupon-{{id}}">
								{!paymentActive && (
									<button
										className="delete-btn"
										ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
										onClick={() =>
											this.setState({
												showDeleteModal: true,
												item: code
											})
										}
									>
										-
									</button>
								)}
								<div className="item-content">
									<div className="item-title">{code.code}</div>
									<div className="line-item">
										<span className="line-title">Coupon</span>
									</div>
								</div>
								<div className="item-price-column">
									<div className="item-price">{code.sale_type === "dollar" ? <NumberFormat value={code.value} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} /> : <NumberFormat value={code.value} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} suffix={"%"} />}</div>
								</div>
							</div>
						);
					} else {
						return (
							<div key={i} className={"cart-summary-item side-summary-item sale-code-item" + (paymentActive ? " no-delete" : "")} data-id="coupon-{{id}}">
								{!paymentActive && (
									<button
										className="delete-btn"
										ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
										onClick={() =>
											this.setState({
												showDeleteModal: true,
												item: code
											})
										}
									>
										-
									</button>
								)}
								<div className="item-content">
									<div className="item-title">Coupon ({code.code})</div>
									<div className="line-item variant-sku">
										<span className="line-title">{code.message ? code.message : ''}</span>
									</div>
								</div>
								<div className="item-price-column">
									<div></div>
								</div>
							</div>
						)
					}
				})}

				{/* DELETE ITEM MODAL */}
				{this.state.showDeleteModal && (
					<Modal
						title={"Delete Item"}
						buttons={[
							{
								type: Button,
								text: "Yes",

								// Either delete coupon or product
								action: !!this.state.item.code
									? this.handleCouponDelete.bind(this, this.state.item.id)
									: this.handleItemDelete.bind(this, this.state.item),

								// Disable when deletion is in process or an error occurs
								disabled:
									this.props.deleteInProcess ||
									!isEmpty(couponDeleteError) ||
									!isEmpty(deleteError) ||
									!!deleteSuccess
							},
							{
								type: Button,
								text: "Close",
								action: this.closeAction.bind(this),
								disabled: this.props.deleteInProcess
							}
						]}
					>
						{this.props.deleteInProcess ? (
							<div className="pt1">
								<Loader />
							</div>
						) : // Errors
						(couponDeleteError || deleteError) && deletedId === this.state.item.id ? (
							<div className="error">
								{deleteError ? deleteError : couponDeleteError}
							</div>
						) : // Success or confirmation message
						deleteSuccess ? (
							<div className="success">{deleteSuccess}</div>
						) : (
							<div>
								Are you sure you want to remove {this.state.item.title} from your
								cart?
							</div>
						)}
					</Modal>
				)}

				{/* UPDATE ITEM MODAL */}
				{this.state.showUpdateModal && (
					<Modal
						title={"Update Item Quantity"}
						buttons={[
							{
								type: Button,
								text: "Ok",
								action: this.handleItemUpdate.bind(this, this.state.item.id),
								disabled: this.props.updateInProcess || this.props.updateSuccess
							},
							{
								type: Button,
								text: "Close",
								action: this.closeAction.bind(this),
								disabled: this.props.updateInProcess
							}
						]}
					>
						{this.props.updateInProcess ? (
							<div className="pt1">
								<Loader />
							</div>
						) : (
							<div>
								<div className="form-field">
									<label>{this.state.item.title} Quantity:</label>
									<input
										className="qty"
										autoFocus
										type="number"
										min="1"
										step="1"
										name="qty"
										placeholder="0"
										defaultValue={this.state.updateQty}
										onChange={this.quantityChange.bind(this)}
										onKeyPress={e =>
											this.handleQtyKeyPress(e, this.state.item.id)
										}
									/>
								</div>
								{this.props.updateSuccess && (
									<div className="success">{this.props.updateSuccess}</div>
								)}
							</div>
						)}
					</Modal>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		items: state.cart.items,
		codes: state.cart.codes,
		paymentActive: state.checkout.paymentActive,
		deleteSuccess: state.cart.deleteSuccess,
		deleteError: state.cart.deleteError,
		couponDeleteError: state.cart.couponDeleteError,
		deletedId: state.cart.deletedId,
		deleteInProcess: state.cart.deleteInProcess,
		updateInProcess: state.cart.updateInProcess,
		updateSuccess: state.cart.updateSuccess,
		clearUpdateMsg: state.cart.clearUpdateMsg
	};
};

export default connect(
	mapStateToProps,
	{
		removeCartProduct,
		removeCartCoupon,
		updateCartQty,
		clearDeleteMsg,
		clearUpdateMsg,
		revertCheckoutAfterCartChanged
	}
)(CheckoutSideProducts);



// WEBPACK FOOTER //
// ./src/components/checkout/side-summary/CheckoutSideProducts.js